import { Box } from '@mui/material';
import { UserEntity } from 'app/interfaces/entity';
import classNames from 'classnames';
import React, { FC } from 'react';
import { UserCardMenu } from 'shared/components/UserCardMenu';
import { UserAvatar } from 'shared/components/UserAvatar';
import { useDefaultUserMenuActions } from 'shared/hooks';
import Highlighter from 'react-highlight-words';
import { useStyles } from './UserHighlighterCard.styles';

interface PlayerTileProps {
  user: UserEntity;
  searchText: string;
}

export const UserHighlighterCard: FC<PlayerTileProps> = ({ user, searchText = '' }) => {
  const { classes } = useStyles();

  const { privateMessageActions, challengeActions, viewProfileAction } =
    useDefaultUserMenuActions();

  const actions = [...privateMessageActions, ...challengeActions, viewProfileAction];

  if (!user) {
    return null;
  }

  return (
    <UserCardMenu data={user} actions={actions}>
      <Box className={classNames(classes.root)}>
        <Box display="flex" alignItems="center">
          <Box className={classes.avatar}>
            <UserAvatar user={user} />
          </Box>
          <Highlighter
            autoEscape={true}
            searchWords={[searchText]}
            className={classes.userName}
            textToHighlight={user.userName}
            highlightClassName={classes.highlight}
          />
        </Box>
        <UserCardMenu readonly />
      </Box>
    </UserCardMenu>
  );
};
